/**
 * Created by koppany.kiss on 2017. 08. 29..
 */

export default function (app) {
	app.directive('stickyBelowTop', function ($document) {
		return {
			restrict: 'A',
			link: function (_scope, _element, _attr) {
				$document.bind("scroll", function () {
					if (_attr.withCondition == 'true') {
						if (window.pageYOffset > 0) {
							angular.element(_element).addClass('sticky');
						} else {
							angular.element(_element).removeClass('sticky');
						}
					}
				});

			}
		};
	});
};
